export class HorseDetailsSaddlery {
            id: string = '';
            horse_detail_id: string = '';
            description: string = '';
            brand: string = '';
          public  sum_insured: number = null;
            color: string = '';
            purchase_date: string = '';
}
